@import "styles/variables";

.button {
  background-color: var(--color-yellow);
  border: 1px solid transparent;
  width: 100%;
  margin: 0;
  padding: 10px 20px;
  font-size: var(--font-size-medium);
  font-family: var(--font-stack-condensed-bold);
  transition: box-shadow 0.1s ease-out, transform 0.1s ease-out;
}
.button:disabled {
  opacity: 0.5;
  pointer-events: none;  
  background-color: var(--color-grey)
}

.button span {
  display: inline-block;
  position: relative;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.button:focus {
  border: 1px solid var(--color-border-orange-focus);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.25), inset 0 -2px 0 var(--color-border-orange-focus);  
  transform: translateY(-1px);
}

.button:active {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0);
  transform: translateY(1px);
}

.small {
  font-size: var(--font-size-small);
}

.medium {
  font-size: var(--font-size-medium);
}

.large {
  padding: 20px;
  font-size: var(--font-size-large);
}

.secondary {  
  background-color: var(--color-dark-grey);
  color: var(--color-light-grey);
}

.secondary:focus {
  border: 1px solid var(--color-border-gray-focus);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.25), inset 0 -2px 0 var(--color-border-gray-focus);
}  

.margin-right {
  margin-right: 20px;
}

.margin-left {
  margin-right: 20px;
}

.loading {
  background-image: url(/static/img/ajax-loader-orange-bg.gif);
  background-repeat: no-repeat;
  background-position: center right 10px;
  background-size: 18px;
}
